import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

export interface ImageViewerProps {
  readonly src: string;
  readonly alt: string;
}

export const IMAGE_VIEWER_MODAL_CLASS = 'image-viewer-modal';

/** Imagen de un evento o producto ampliada sobre la pantalla actual, con una cruz para cerrarla. */
@Component({
  selector: 'app-image-viewer-modal',
  templateUrl: './image-viewer-modal.component.html',
  styleUrls: ['./image-viewer-modal.component.scss'],
  standalone: false,
})
export class ImageViewerModalComponent {
  @Input({ required: true }) src!: string;
  @Input() alt = '';

  constructor(private readonly modalCtrl: ModalController) {}

  static async open(modalCtrl: ModalController, props: ImageViewerProps): Promise<void> {
    const modal = await modalCtrl.create({
      component: ImageViewerModalComponent,
      componentProps: { ...props },
      cssClass: IMAGE_VIEWER_MODAL_CLASS,
      backdropDismiss: true,
    });
    await modal.present();
  }

  close(): void {
    this.modalCtrl.dismiss();
  }
}
